// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBCfw937BgigbfI6e8JBwal9vMJtBUKm6M",
    authDomain: "galaxy-card-application.firebaseapp.com",
    projectId: "galaxy-card-application",
    storageBucket: "galaxy-card-application.appspot.com",
    messagingSenderId: "588312056495",
    appId: "1:588312056495:web:a214053a55656c55c1fa5a",
    measurementId: "G-7E17BMJ596"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
